<template
  ><div class="ts-border ts-p-3 ts-rounded-md ts-space-y-3">
    <div>
      <h3
        class="ts-text-lg ts-font-semibold ts-bg-blue-100 ts-px-2 ts-rounded-md ts-py-1 ts-text-blue-500"
        style="width: fit-content;"
      >
        {{ $t('single-copy.monthly_score') }}
      </h3>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="required">{{ $t('single-copy.main_program') }}</label>
        <a-select
          v-model="model.acp_id"
          :placeholder="$t('single-copy.select_main_program')"
          show-search
          :filter-option="filterOption"
          :loading="loading"
          :disabled="loading"
          style="width: 100%"
          :options="mainProgramOptions"
          @change="onFetchTermSemester"
        ></a-select>
        <div v-if="errors.has('acp_id')">
          <span class="text-danger">{{ errors.first('acp_id') }}</span>
        </div>
      </div>
      <div class="col-md-4">
        <label class="required">{{ $t('single-copy.academic_term') }}</label>
        <a-select
          v-model="model.ac_term_id"
          :placeholder="$t('single-copy.select_academic_term')"
          show-search
          :filter-option="filterOption"
          :loading="loading"
          :disabled="loading"
          style="width: 100%"
          :options="termSemesterOptions"
          @change="onFetchClass"
        ></a-select>
        <div v-if="errors.has('ac_term_id')">
          <span class="text-danger">{{ errors.first('ac_term_id') }}</span>
        </div>
      </div>
      <div class="col-md-4">
        <label class="required">{{ $t('single-copy.academic_classes') }}</label>
        <a-select
          v-model="model.class_id"
          :placeholder="$t('single-copy.select_academic_classes')"
          show-search
          :filter-option="filterOption"
          :loading="loading"
          :disabled="loading"
          style="width: 100%"
          :options="academicClassOptions"
          @change="onClassChange"
        ></a-select>
        <div v-if="errors.has('class_id')">
          <span class="text-danger">{{ errors.first('class_id') }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="required">{{ $t('single-copy.scoring_cycle') }}</label>
        <a-select
          v-model="model.m_scoring_cycle_id"
          show-search
          :filter-option="filterOption"
          :loading="loading"
          :disabled="true"
          style="width: 100%"
          :options="scoringCyleOption"
        ></a-select>
        <div v-if="errors.has('class_id')">
          <span class="text-danger">{{ errors.first('class_id') }}</span>
        </div>
      </div>
      <div class="col-md-4">
        <label class="required">{{ $t('single-copy.cycle_value') }}</label>
        <a-select
          v-model="model.m_cycle_value"
          show-search
          :filter-option="filterOption"
          :placeholder="$t('single-copy.select_cycle_value')"
          :loading="loading"
          :disabled="loading"
          style="width: 100%"
          :options="cycleValueOptions"
        ></a-select>
        <div v-if="errors.has('m_cycle_value')">
          <span class="text-danger">{{ errors.first('m_cycle_value') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapMutations } from 'vuex'
import notificationAlert from '@/utils/NotificationAlert'
export default {
  name: 'MonthlyScore',
  props: ['value'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      loading: false,
      mainProgramOptions: [],
      termSemesterOptions: [],
      academicClassOptions: [],
      cycleValueOptions: []
    }
  },
  created() {
    this.model = this.value
    this.onFetchMainProgram()
  },
  computed: {
    statusName: () => statusId => {
      switch (statusId) {
        case 1:
          return 'Current'
        case 2:
          return 'History'
        case 3:
          return 'Next'
        default:
          return 'unknown'
      }
    },
    scoringCyleOption() {
      return [
        {
          value: 1,
          label: 'Monthly Score'
        },
        {
          value: 2,
          label: 'Semester Score'
        }
      ]
    }
  },
  methods: {
    ...mapActions('scoreCopy', ['formViewModel']),
    ...mapMutations('scoreCopy', ['SET_LOADING']),
    onFetchMainProgram() {
      this.SET_LOADING(true)
      this.formViewModel({
        fnName: 'main_program'
      })
        .then(response => {
          if (response.status === 200) {
            this.mainProgramOptions = response.data.main_program.map(item => {
              return {
                value: item.acp_id,
                label: item.acp_name_native + ' - ' + item.acp_name_foreign
              }
            })
          } else {
            notificationAlert(response)
          }
        })
        .catch(error => {
          notificationAlert(error)
        })
        .finally(() => {
          this.SET_LOADING(false)
        })
    },
    onFetchTermSemester() {
      this.SET_LOADING(true)
      this.model.ac_term_id = undefined
      this.model.class_id = undefined
      this.termSemesterOptions = []
      this.model.students = []
      this.model.m_cycle_value = undefined
      this.formViewModel({
        fnName: 'term_semester',
        acp_id: this.model.acp_id
      })
        .then(response => {
          if (response.status === 200) {
            this.termSemesterOptions = response.data.term_semester.map(item => {
              return {
                value: item.ac_term_id,
                label: item.term_name,
                term_order: item.term_order,
                acps_id: item.acps_id
              }
            })
          } else {
            notificationAlert(response)
          }
        })
        .catch(error => {
          notificationAlert(error)
        })
        .finally(() => {
          this.SET_LOADING(false)
        })
    },
    onFetchClass(_value, option) {
      const { acps_id, term_order } = option.data.props
      this.SET_LOADING(true)
      this.model.class_id = undefined
      this.model.cycle_value = term_order
      this.model.students = []
      this.formViewModel({
        fnName: 'academic_class,cycle_value',
        ac_term_id: this.model.ac_term_id,
        acps_id,
        semester_order: term_order
      })
        .then(response => {
          if (response.status === 200) {
            this.cycleValueOptions = response.data.cycle_value.map(item => {
              return {
                value: item.scoring_cycle_value,
                label: item.scoring_cycle_description
              }
            })
            this.academicClassOptions = response.data.academic_class.map(
              item => {
                return {
                  value: item.class_id,
                  label: `${item.class_name}-(${this.statusName(
                    item.ac_status_id
                  )})`,
                  score_type: item.score_type,
                  semester_score_sc_bas_id: item.semester_score_sc_bas_id,
                  ac_category_id: item.ac_category_id,
                  grade_id: item.grade_id,
                  ac_year_id: item.ac_year_id,
                }
              }
            )
          } else {
            notificationAlert(response)
          }
        })
        .catch(error => {
          notificationAlert(error)
        })
        .finally(() => {
          this.SET_LOADING(false)
        })
    },
    onClassChange(_value, option) {
      this.model.score_sc_bas_id = option.data.props.semester_score_sc_bas_id
      this.model.score_type = option.data.props.score_type
      this.model.ac_category_id = option.data.props.ac_category_id
      this.model.ac_year_id = option.data.props.ac_year_id
    },
    filterOption(input, option) {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
